const UploadedMomentsEmptyState = () => (
  <div className="flex flex-col items-center justify-center">
    <div className="flex-1 flex flex-col items-center justify-center">
      <div>
        <img src="/img/events/create/moments.png" className="mx-auto" />
      </div>
      <div className="text-[14px] font-bold">
        <b>No Moments Yet!</b>
      </div>
      <div className="mt-2 text-sm text-gray-600 font-normal">
        Uploaded files will appear here.
      </div>
    </div>
  </div>
);

export default UploadedMomentsEmptyState;
